import { PreloadedState, combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import defaultState from './defaultState';
import { paylinkApi } from './modules/paylink/api';
import { mmsApi } from './modules/merchant/api';
import { omsApi } from './modules/orders/api';
import { mitApi } from './modules/mit/api';
import { insightsApi } from './modules/insights/api';
import { webhooksApi } from './modules/webhooks/api';
import { ellaDataLayerApi } from './modules/ellaDataLayer/api';
import { ecomConnectorApi } from './modules/ecomConnector/api';
import { runtimeConfig } from '../config/runtimeConfig';

const isDev =
  import.meta.env.DEV || runtimeConfig.apiBaseNewUrl === 'https://dev-merchants.skipify.com/v1';

const rootReducer = combineReducers({
  [paylinkApi.reducerPath]: paylinkApi.reducer,
  [mmsApi.reducerPath]: mmsApi.reducer,
  [omsApi.reducerPath]: omsApi.reducer,
  [mitApi.reducerPath]: mitApi.reducer,
  [insightsApi.reducerPath]: insightsApi.reducer,
  [webhooksApi.reducerPath]: webhooksApi.reducer,
  [ellaDataLayerApi.reducerPath]: ellaDataLayerApi.reducer,
  [ecomConnectorApi.reducerPath]: ecomConnectorApi.reducer,
});

const setupStore = (preloadedState: PreloadedState<RootState> = defaultState) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat([thunk])
        .concat(paylinkApi.middleware)
        .concat(mmsApi.middleware)
        .concat(omsApi.middleware)
        .concat(mitApi.middleware)
        .concat(insightsApi.middleware)
        .concat(webhooksApi.middleware)
        .concat(ellaDataLayerApi.middleware)
        .concat(ecomConnectorApi.middleware),
    devTools: isDev,
    preloadedState,
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

export default setupStore;
